import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleProfessionalReport } from 'domain/usecases';

export class RemoteHandleProfessionalReport
  implements HandleProfessionalReport
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleProfessionalReport.Result[]>,
  ) {}

  async execute(
    params: HandleProfessionalReport.Params,
  ): Promise<HandleProfessionalReport.Result[]> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(`${this.url}/${params.type}`, params as any),
      responseType: params.type !== '2' ? 'arraybuffer' : 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
